import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const [params] = useSearchParams();
  const error = params.get("error");
  const startLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="min-h-screen flex flex-col">
      <Seo title="Admin-innlogging | NOUROZI EBYGG & ANLEGG" description="Innlogging for administrator." path="/admin/login" />
      <Header />
      <main className="flex-1 grid place-items-center py-16">
        <div className="w-full max-w-md bg-white border border-[#E2DDD5] rounded-2xl p-8">
          <div className="w-12 h-12 rounded-md bg-[#1B3626] text-white grid place-items-center font-display font-black text-lg">N</div>
          <h1 className="mt-5 font-display text-2xl font-bold">Admin-innlogging</h1>
          <p className="mt-2 text-sm text-[#555E68]">Kun forhåndsgodkjente e-poster har tilgang til dashbordet. Logg inn med Google-kontoen din.</p>
          {error && <div className="mt-4 rounded-md bg-[#FCE9E4] border border-[#E5A99A] text-[#8C2F19] px-3 py-2 text-sm">Innlogging feilet. Prøv igjen.</div>}
          <button onClick={startLogin} className="btn-primary w-full mt-6" data-testid="google-login-btn">
            <LogIn size={16} /> Logg inn med Google
          </button>
          <Link to="/" className="block text-center text-sm text-[#555E68] mt-4 hover:text-[#1B3626]">← Tilbake til nettsiden</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
